import { isNud } from '@/shared/utilities/typing'
import School from '@/shared/models/entities/school';
import SchoolRole from '../enums/school-role';
import { dateYmdHi } from '@/shared/utilities/date-format';

/**
 * 先生 エンティティ
 */
class Teacher {
    teacher_id;
    teacher_name;
    school;
    user_login;
    password;
    role;
    email;
    provisional_password;
    provisional_expired;

    constructor(properties) {
        if (isNud(properties)) {
            properties = {};
        }

        this.teacher_id = properties.teacher_id;
        this.teacher_name = properties.teacher_name;
        this.school = new School(properties.school);
        this.user_login = properties.user_login;
        this.password = properties.password;
        this.role = properties.role;
        this.email = properties.email;
        this.provisional_password = properties.provisional_password;
        this.provisional_expired = properties.provisional_expired;
    }

    get role_display() {
        return SchoolRole.get(this.role);
    }

    get provisional_expired_display() {
        return dateYmdHi(this.provisional_expired);
    }
}

export default Teacher;
